import React from "react";
import { Link } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { ApiService } from "../../../../services/ApiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function ReviewDetails({ closeModal, alert, id }) {
  console.log("iddddddddd", id);
  return (
    <React.Fragment>
      <Formik
        initialValues={{
          what_went_well: "",
          what_didnt_go_well: "",
          what_should_be_improved: "",
          general_comment: "",
        }}
        onSubmit={async (values, { setSubmitting }) => {
          ApiService.post(
            `events/submit-apparaisal-for-employee/${id}`,
            values
          ).then((res) => {
            if (res.data.type === false) {
              setSubmitting(false);
              alert.error(res.data.msg);
            } else if (res.data.type === true) {
              alert.success(res.data.msg);
              history.push("/dashboard/performance");
            }
          });
          console.log(values);
        }}
      >
        {({ isSubmitting, values, handleChange }) => (
          <Form>
            <div class="row">
              <div
                class="col-md-12 performance-review-wrapper"
                id="performance-review-wrapper"
              >
                <div class="accordion" id="accordionExample">
                  <div class="card review_accordion">
                    <div>
                      <h4 class="text-dark">PERFORMANCE REVIEW</h4>
                    </div>

                    <div
                      class="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="">
                          <div class="form-group">
                            <label>What went well </label>
                            <textarea
                              class="form-control"
                              cols="30"
                              rows="10"
                              id="what_went_well"
                              name="what_went_well"
                              value={values.what_went_well}
                              onChange={handleChange}
                            >
                              went well
                            </textarea>
                          </div>

                          <div class="form-group">
                            <label>What didn't go well </label>
                            <textarea
                              class="form-control"
                              cols="30"
                              rows="10"
                              id="what_didnt_go_well"
                              name="what_didnt_go_well"
                              value={values.what_didnt_go_well}
                              onChange={handleChange}
                            >
                              didn't go well
                            </textarea>
                          </div>

                          <div class="form-group">
                            <label>What should be improved on </label>
                            <textarea
                              class="form-control"
                              cols="30"
                              rows="10"
                              id="what_should_be_improved"
                              name="what_should_be_improved"
                              value={values.what_should_be_improved}
                              onChange={handleChange}
                            >
                              what to improve
                            </textarea>
                          </div>

                          <div class="form-group">
                            <label>General Comment </label>
                            <textarea
                              class="form-control"
                              cols="30"
                              rows="10"
                              id="general_comment"
                              name="general_comment"
                              value={values.general_comment}
                              onChange={handleChange}
                            >
                              General comment
                            </textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group m-auto row pt-2">
              <div className="col">
                <button type="button" className="btn btn-danger btn-sm">
                  Cancel
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Update{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/perfomancemanagement/modals/reviewForm.js